import { Button } from '@nextui-org/react';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
`;

export const FilterButtonGroup = styled(Button.Group)`
  gap: 8px;
`;

export const FilterButton = styled(Button).attrs((props) => {
  const isSelected = props.$selected;
  return {
    css: {
      boxSizing: 'content-box',
      height: `${props.theme.lineHeight.m} !important`,
      background: isSelected ? `${props.theme.colors.primary.c200} !important` : props.theme.colors.white,
      border: isSelected
        ? `1px solid ${props.theme.colors.primary.c600} !important`
        : `1px solid ${props.theme.colors.greyscale.c300} !important`,
      span: {
        'font-weight': isSelected
          ? `${props.theme.fontWeight.semibold} !important`
          : `${props.theme.fontWeight.regular} !important`,
        color: isSelected
          ? `${props.theme.colors.primary.c700} !important`
          : `${props.theme.colors.greyscale.c800} !important`,
        height: `${props.theme.lineHeight.m} !important`,
      },
    },
  };
})`
  border-radius: 100px !important;
  padding: 0.5rem 1rem !important;
`;
